/* eslint-disable no-shadow */
import { usePageData } from '@composables/usePageData';
import useSelectedMemberId from '@modules/latchkey/composables/useSelectedMemberId';
import parseStatisticsData from '../reviewsStore/parsers/parseStatisticsData';
import parseGeneratedSummary from '../reviewsStore/parsers/parseGeneratedSummary';
import { FETCH_REVIEWS } from '../../types/actions';
import { GET_ALL_PRODUCTS_DATA } from '../../types/getters';
import {
  SET_PRODUCT_DATA,
  SET_REVIEWS,
  SET_REVIEWS_STATISTICS,
  SET_REVIEWS_TOTAL_RESULTS,
  SET_GENERATED_SUMMARY,
} from '../../types/setters';
/**
 * @param {import ('./productStore').ProductStoreState} state
 * @param {number} productId
 * @returns {boolean}
 */
function isCached(state, productId) {
  return !!state.productData[productId];
}
/**
 * @returns {import ('./productStore').ProductStoreState}
 */
export function state() {
  return {
    productData: {},
    pageUtagData: null,
  };
}

export const mutations = {
  /**
  * @param {import ('./productStore').ProductStoreState} state
  * @param {{ productId: number, data: Product }} productId
  */
  [SET_PRODUCT_DATA](state, { productId, data }) {
    state.productData[productId] = data;
  },
};

export const getters = {
  /**
  * @param {unknown} _
  * @param {unknown} __
  * @param {{ pageData: { product: { product: Product }}} } rootState
  */
  [GET_ALL_PRODUCTS_DATA](_, __, rootState) {
    // TODO break out member products in node so getter caching not needed
    const { product } = rootState.pageData.product;
    const data = { [product.id]: product };

    if (product.detail?.flags?.masterProduct) {
      const memberProductMap = product.relationships?.memberProductMap;
      const { ccfp } = product;

      if (memberProductMap) {
        Object.entries(memberProductMap).forEach(([memberId, memberData]) => {
          data[memberId] = {
            ...memberData,
            ccfp,
          };
        });
      }
    }
    return data;
  },
};

export const actions = {
  // TODO: refactor this action
  /**
  * @param {unknown} context
  * @param {{productId: number}} productId
  */
  async init({ commit, state, dispatch }, { productId }) {
    if (isCached(state, productId)) {
      return;
    }

    const { product: result } = usePageData();

    /**
     *
     * @param {Product} product
     */
    function handleResponse(product) {
      if (product?.detail?.flags?.isConsolidatedThirdVariant) {
        const selectedMemberId = useSelectedMemberId();
        dispatch(`reviewsStore/${FETCH_REVIEWS}`, { productId: selectedMemberId.value }, { root: true });
      } else {
        commit(`reviewsStore/${SET_REVIEWS}`, product?.review?.reviews || [], { root: true });
        commit(`reviewsStore/${SET_GENERATED_SUMMARY}`, parseGeneratedSummary(product?.review?.generatedSummary), { root: true });

        if (product?.review?.includes?.products
            && productId
            && product?.review?.includes?.products?.[productId]?.reviewStatistics) {
          const statistics = product.review.includes.products[productId].reviewStatistics;
          commit(`reviewsStore/${SET_REVIEWS_STATISTICS}`, parseStatisticsData(statistics), { root: true });
        }
        commit(
            `reviewsStore/${SET_REVIEWS_TOTAL_RESULTS}`,
            product?.review?.totalResults || 0,
            { root: true },
        );
      }
    }

    if (result) {
      handleResponse(result.product);
    }
  },
};
